var React = require('react');

function LinkedAbove (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.93921 7.00002L6.99987 2.93936L11.0605 7.00002L9.99987 8.06068L7.74974 5.81055V11.25H12.7497V12.75H6.24974V5.81081L3.99987 8.06068L2.93921 7.00002Z","fill":"#181818"}));
}

LinkedAbove.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LinkedAbove;

LinkedAbove.default = LinkedAbove;
